import CustomIcon from '@components/utils/CustomIcon';
import { FillFireIcon } from '@assets/icons';
import Typography from '@components/Typography';
import { SearchViewModel } from '@api/v3';

import { Container, Header, Item, ItemsWrapper } from './styled';

type PopularSearchesProps = {
  items?: SearchViewModel[];
  onSelectItem?: (item: SearchViewModel) => void;
};

const PopularSearches = ({ items, onSelectItem }: PopularSearchesProps) => {
  return (
    <Container>
      <Header>
        <CustomIcon
          icon={FillFireIcon}
          fontSize={24}
          paletteColor='BR300'
          style={{ marginTop: '-4px' }}
        />
        <Typography variant='caption2' color='BR300' weight='Bold'>
          Popüler Aramalar
        </Typography>
      </Header>

      <ItemsWrapper>
        {Array.isArray(items) &&
          items.map((item) => (
            <Item key={item.id} onClick={() => onSelectItem?.(item)}>
              <p>{item?.text}</p>
            </Item>
          ))}
      </ItemsWrapper>
    </Container>
  );
};

export default PopularSearches;
